import React, { useState, useEffect, useContext, useRef } from "react";
import {
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	IconButton,
} from "@material-ui/core";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import VerificationPhone from "../VerificationPhone/VerificationPhone";
import { LangContext } from "../../context/AppContext";
import "react-day-picker/dist/style.css";

// API
import { api_get_hospital_listings } from "../../api/hospital";
import {
	api_em_doctor_listing,
	api_em_doctor_tenantcode,
} from "../../api/doctor";
import {
	createAppointment,
	generateTZDate,
	doctorCalendar,
	doctorTimeslot,
	convertTZDate,
	getDoctor,
} from "../../api/encoremed/encoremed";
import { save_appointment, update_appointment } from "../../api/appointment";
import { api_get_account } from "../../api/profile/setting";

//calendar settings
import { DayPicker } from "react-day-picker";
import { BsFillSquareFill } from "react-icons/bs";
import { FaCalendarAlt } from "react-icons/fa";

import { send_mail } from "../../api/mail";
import { api_get_ipc } from "../../api/ipc";
import countriesWithCode from "../../context/CountriesListing";
import { api_get_subspeciality } from "../../api/speciality_centre";

// components
import TextBox from "../TextBox/TextBox";
import Dropdown from "../Dropdown/dropdown";
import DropdownCountry from "../Dropdown/dropdownCountry";
import DropdownHospitalListing from "./subComponents/DropdownHospitalListing";
import DropdownSpecialisationListing from "./subComponents/DropdownSpecialisationListing";
import DropdownDoctorListing from "./subComponents/DropdownDoctorListing";

const genderoptions = [
	{ value: "MALE", label: "Male" },
	{ value: "FEMALE", label: "Female" },
];

const MakeAnAppointmentPopup = ({ isOpen, onClose, prefillData }) => {
	const { selectedLanguage } = useContext(LangContext);

	const isLogging = localStorage.getItem("patient_id");

	const [currentStep, setCurrentStep] = useState(1);

	const [hospitalListing, setHospitalListing] = useState([]);
	const [doctorListing, setDoctorListing] = useState([]);
	const [doctorFullListing, setDoctorFullListing] = useState([]);

	const [selectedHospital, setSelectedHospital] = useState(
		prefillData?.hospital_id || prefillData?.clinical_id || ""
	);
	const [locationType, setLocationType] = useState(
		prefillData?.clinical_id
			? "clinic"
			: prefillData?.hospital_id
			? "hospital"
			: ""
	);

	const [selectedSpecialisation, setSelectedSpecialisation] = useState(
		prefillData?.specialtys || ""
	);
	const [selectedDoctor, setSelectedDoctor] = useState(
		prefillData?.doctor_id ? prefillData?.doctor_id : ""
	);
	const [selectedDate, setSelectedDate] = useState(
		prefillData?.selected_date ?? ""
	);
	const [selectedOriDate, setSelectedOriDate] = useState(
		prefillData?.selected_date ? dayjs(prefillData.selected_date) : dayjs()
	);
	const [selectedTime, setSelectedTime] = useState(
		prefillData?.selected_time
			? dayjs(prefillData.selected_time).format("hh:mm A")
			: ""
	);
	const [allowedDates, setAllowedDates] = useState(null);
	const [allowedTimes, setAllowedTimes] = useState([]);
	const [invalidForm, setInvalidForm] = useState([]);
	const [countriesListing, setCountriesListing] = useState([]);
	const [isCalendarOpen, setIsCalendarOpen] = useState(false);
	const [makeAppointmentLoading, setMakeAppointmentLoading] = useState(false);
	const [isAdditionalFields, setIsAdditionalFields] = useState(false);

	// patient details form usestate
	const [patientName, setPatientName] = useState("");
	const [patientNric, setPatientNric] = useState("");
	const [patientResidence, setPatientResidence] = useState("Malaysia");
	const [residenceCode, setResidenceCode] = useState("");
	const [patientGender, setPatientGender] = useState("");
	const [patientEmail, setPatientEmail] = useState("");
	const [patientPhoneNum, setPatientPhoneNum] = useState("");
	const [patientCallingCode, setPatientCallingCode] = useState("+60");

	// AM/PM related
	const [isAppointmentRequest, setIsAppointmentRequest] = useState(false);

	// additional fields
	const [visitTypes, setVisitTypes] = useState([]);
	const [selectedVisitType, setSelectedVisitType] = useState({
		id: null,
		name: null,
	});
	const [extraFields, setExtraFields] = useState([]);
	const [selectedPaymentType, setSelectedPaymentType] = useState("");
	const [extraFieldsValue, setExtraFieldsValue] = useState(null);

	// doctor specialisation, used on after select doctor, assigned after api_em_doctor_listing
	const [doctorSpecialisations, setDoctorSpecialisations] = useState(null);

	// for encoremed use, array of hospital_id and tenant code
	const [tenantCodes, setTenantCodes] = useState([]);

	// store doctor
	const [selectedDoctorDetails, setSelectedDoctorDetails] = useState([]);
	const [selectedDoctorSpecialty, setselectedDoctorSpecialty] = useState([]);

	const validateForm = (formData) => {
		let _invalidForm = [...invalidForm];
		// do validation on form data
		for (const [key, value] of Object.entries(formData)) {
			if (value === "") {
				if (!_invalidForm.includes(key)) {
					_invalidForm.push(key);
					setInvalidForm(_invalidForm);
				}
			} else {
				const indexToRemove = _invalidForm.indexOf(key);
				if (indexToRemove !== -1) {
					_invalidForm.splice(indexToRemove, 1);
				}
				setInvalidForm(_invalidForm);
			}
		}

		return _invalidForm.length === 0;
	};

	const handleClose = () => {
		setCurrentStep(1);
		setSelectedHospital("");
		setSelectedSpecialisation("");
		setSelectedDoctor("");
		setSelectedDate("");
		setSelectedTime("");
		setPatientName("");
		setPatientNric("");
		setPatientResidence("");
		setPatientGender("");
		setPatientEmail("");
		setPatientPhoneNum("");
		setSelectedDoctorDetails({});
		setselectedDoctorSpecialty({});
		localStorage.selectedDay = "";
		localStorage.topicsLastReferenceTime = "";
		onClose();
		setIsAdditionalFields(false);
	};

	const handleDateChange = (date) => {
		setSelectedDoctorDetails(assignDoctorDetails());
		setselectedDoctorSpecialty(assignSelectedDoctorSpecialty());
		assignSelectedDate();
		setPatientResidence(assignSelectedCountry());

		const doctorId =
			selectedDoctorDetails?.value || selectedDoctor || prefillData?.doctor_id;

		const _date = new Date(date);
		var _convertedDate = `${_date.getFullYear()}-${(_date.getMonth() + 1)
			.toString()
			.padStart(2, "0")}-${_date.getDate().toString().padStart(2, "0")}`;
		setSelectedDate(_convertedDate);
		setSelectedOriDate({ $d: date });
		// call get timeslot API
		const _timeslots = [];
		let _tenantCode = "";
		if (locationType == "hospital") {
			_tenantCode = tenantCodes?.[`h_${selectedHospital}`]?.tenantcode;
		} else {
			_tenantCode = tenantCodes?.[`c_${selectedHospital}`]?.tenantcode;
		}
		doctorTimeslot(_convertedDate, doctorId, _tenantCode)
			.then((res) => {
				if (res.status) {
					/*********************************************************************/
					// AM/PM related
					// 9/8/2024, check 12AM/12PM or not, if yes then need change to AM/PM
					if (
						res?.data?.timeslots?.length === 2 &&
						res?.data?.timeslots?.[0].isAvailable &&
						res?.data?.timeslots?.[0].isWorkingDay &&
						convertTZDate(res?.data?.timeslots?.[0].timestamp, "0").timeNoSec ==
							"12:00 AM" &&
						res?.data?.timeslots?.[1].isAvailable &&
						res?.data?.timeslots?.[1].isWorkingDay &&
						convertTZDate(res?.data?.timeslots?.[1].timestamp, "0").timeNoSec ==
							"12:00 PM"
					) {
						setIsAppointmentRequest(true); // AM/PM
						// need to check
						_timeslots.push({
							value: "12:00 AM",
							label: "AM",
						});
						_timeslots.push({
							value: "12:00 PM",
							label: "PM",
						});
					} else {
						setIsAppointmentRequest(false); // AM/PM
						res.data.timeslots.forEach((element) => {
							if (element.isAvailable && element.isWorkingDay) {
								_timeslots.push({
									value: convertTZDate(element.timestamp, 0).timeNoSec,
									label: convertTZDate(element.timestamp, 0).timeNoSec,
								});
							}
						});
					}
					/*********************************************************************/
				}
				setAllowedTimes(_timeslots);
			})
			.catch((err) => {
				console.log(err);
				setAllowedTimes([]);
			});
	};

	const handleFormStep = (type) => {
		// 25/9/2023
		// currentStep = 1 = first form(patient details + appointment details)
		// currentStep = 2 = Please confirm your appointment (summary of details)
		if (currentStep + 1 === 2) {
			// going to summary of details, so need to check all form info is ok or not
			// check all fields, if invalid then find the label and add warning css
			const _v = validateForm({
				selectedHospital,
				selectedSpecialisation,
				selectedDoctor,
				selectedDate,
				selectedTime,
				patientName,
				patientNric,
				patientResidence,
				patientGender,
				patientEmail,
				patientPhoneNum,
			});

			if (!_v) {
				return false;
			}
		}
		switch (type) {
			case "next":
				setCurrentStep(currentStep + 1);
				break;
			case "prev":
				setCurrentStep(currentStep - 1);
				break;
			default:
				break;
		}
	};

	const handleDoctorChange = async (doctorId) => {
		setSelectedDoctor(doctorId);

		const _calendars = [];
		setAllowedTimes([]);

		let _tenantCode =
			locationType === "hospital"
				? tenantCodes[`h_${selectedHospital}`]?.tenantcode
				: locationType === "clinic"
				? tenantCodes[`c_${selectedHospital}`]?.tenantcode
				: "";

		try {
			const resCalendar = await doctorCalendar(
				selectedOriDate.$d.getMonth() + 1,
				selectedOriDate.$d.getFullYear(),
				doctorId,
				_tenantCode
			);
			if (resCalendar.status) {
				resCalendar.data.calendars.forEach((element) => {
					if (element.isAvailable && element.isWorkingDay) {
						_calendars.push(element.selectedDate);
					}
				});
			}
			// setSelectedDate("");
			setAllowedDates(_calendars);
		} catch (err) {
			console.log(err);
			setAllowedDates([]);
		}

		try {
			const res = await getDoctor(doctorId, _tenantCode);
			const resData = res.data.doctor;
			setExtraFields(resData.config.appointmentExtraFields);
			setVisitTypes(resData.visitTypes);
			if (
				resData.config.appointmentExtraFields.length > 0 ||
				resData.visitTypes.length > 0
			) {
				setIsAdditionalFields(true);
			}
		} catch (error) {}
	};

	// when user change month/year
	const handleDatePickerChange = (date) => {
		// var _date = date.$d;
		const _date = new Date(date);
		const yearMonth = {
			month: _date.getMonth() + 1,
			year: _date.getFullYear(),
		};
		const _calendars = [];
		// get EM calendar API
		let _tenantCode = "";
		if (locationType == "hospital") {
			_tenantCode = tenantCodes[`h_${selectedHospital}`]?.tenantcode;
		} else {
			_tenantCode = tenantCodes[`c_${selectedHospital}`]?.tenantcode;
		}
		doctorCalendar(
			String(yearMonth.month).padStart(2, "0"),
			yearMonth.year,
			selectedDoctorDetails?.value,
			_tenantCode
		)
			.then((res) => {
				if (res.status) {
					res.data.calendars.forEach((element) => {
						if (element.isAvailable && element.isWorkingDay) {
							_calendars.push(element.selectedDate);
						}
					});
				}
				setAllowedDates(_calendars);
			})
			.catch((err) => {
				console.log(err);
				setAllowedDates([]);
			});
	};

	const generateFromIc = (ic) => {
		if (!ic || ic.length !== 12) {
			return "";
		}

		if (ic.length === 12) {
			// generate
			const dobPart = ic.slice(0, 6);
			let dobYear = dobPart.slice(0, 2);

			// Check if dobYear is for year 2000 and above
			if (parseInt(dobYear) >= 0 && parseInt(dobYear) <= 20) {
				dobYear = `20${dobYear}`; // Change to 20xx
			} else {
				dobYear = `19${dobYear}`; // Otherwise keep it as 19xx
			}

			const dob = `${dobYear}-${dobPart.slice(2, 4)}-${dobPart.slice(4, 6)}`;

			// Extract last 2 digits for gender determination
			const genderDigit = parseInt(ic.slice(-2));

			// Determine gender based on the last digit
			const gender = genderDigit % 2 === 0 ? "FEMALE" : "MALE";

			return { dob, gender };
		}
	};

	const handleNricInput = (e) => {
		const inputValue = e.target.value;
		// const numericValue = inputValue.replace(/[^\d-]/g, "");
		const sanitizedValue = inputValue.replace(/-/g, "");

		setPatientNric(sanitizedValue);
	};

	const handleExtraFieldsInput = (index, value) => {
		setExtraFieldsValue({
			...extraFieldsValue,
			[extraFields?.[index]?.name]: value,
		});
	};

	// fetch country listing
	const fetchCountriesListing = async () => {
		try {
			const res = await api_get_ipc();
			if (res.status) {
				const dataFromApi = res.data[selectedLanguage]?.country;
				setCountriesListing(dataFromApi);
			}
		} catch (error) {
			console.error(error);
		}
	};

	// for API
	const limit = 1000; // to fetch all hospitals
	const offset = 0;

	const fetchHospitalListing = async (limit, offset) => {
		try {
			const data = await api_get_hospital_listings(
				selectedLanguage,
				limit,
				offset
			);

			return data;
		} catch (error) {
			console.error(error);
			return {
				status: false,
				error: true,
			};
		}
	};

	if (prefillData?.doctor_id && selectedDoctor === "") {
		setSelectedDoctor(prefillData.doctor_id);
		setSelectedSpecialisation(prefillData.specialtys);
		// get EM calendar API
		const _calendars = [];
		api_em_doctor_tenantcode(prefillData.doctor_id).then((t_res) => {
			if (t_res.status) {
				const _tenantCode = t_res.data.tenantcode;
				doctorCalendar(
					selectedOriDate.$d.getMonth() + 1,
					selectedOriDate.$d.getFullYear(),
					prefillData.doctor_id,
					_tenantCode
				)
					.then((res) => {
						if (res.status) {
							res.data.calendars.forEach((element) => {
								if (element.isAvailable && element.isWorkingDay) {
									_calendars.push(element.selectedDate);
								}
							});
						}
						setAllowedDates(_calendars);
					})
					.catch((err) => {
						console.log(err);
						setAllowedDates([]);
					});
			}
		});
	}
	if (
		prefillData?.selected_date &&
		prefillData?.selected_time &&
		selectedTime === ""
	) {
		setSelectedTime(prefillData?.selected_time);
		// call get timeslot API
		const _timeslots = [];
		api_em_doctor_tenantcode(prefillData.doctor_id).then((t_res) => {
			if (t_res.status) {
				const _tenantCode = t_res.data.tenantcode;
				doctorTimeslot(
					prefillData?.selected_date,
					prefillData?.doctor_id,
					_tenantCode
				)
					.then((res) => {
						if (res.status) {
							/*********************************************************************/
							// AM/PM related
							// 9/8/2024, check 12AM/12PM or not, if yes then need change to AM/PM
							if (
								res?.data?.timeslots?.length === 2 &&
								res?.data?.timeslots?.[0].isAvailable &&
								res?.data?.timeslots?.[0].isWorkingDay &&
								convertTZDate(res?.data?.timeslots?.[0].timestamp, "0")
									.timeNoSec == "12:00 AM" &&
								res?.data?.timeslots?.[1].isAvailable &&
								res?.data?.timeslots?.[1].isWorkingDay &&
								convertTZDate(res?.data?.timeslots?.[1].timestamp, "0")
									.timeNoSec == "12:00 PM"
							) {
								setIsAppointmentRequest(true); // AM/PM
								// need to check
								_timeslots.push({
									value: "12:00 AM",
									label: "AM",
								});
								_timeslots.push({
									value: "12:00 PM",
									label: "PM",
								});
							} else {
								setIsAppointmentRequest(false); // AM/PM
								res.data.timeslots.forEach((element) => {
									if (element.isAvailable && element.isWorkingDay) {
										_timeslots.push({
											value: convertTZDate(element.timestamp, 0).timeNoSec,
											label: convertTZDate(element.timestamp, 0).timeNoSec,
										});
									}
								});
							}
							/*********************************************************************/
						}
						setAllowedTimes(_timeslots);
					})
					.catch((err) => {
						console.log(err);
						setAllowedTimes([]);
					});
			}
		});
	}

	// submit form
	const handleButtonClick = () => {
		/*******************************************/
		// convert 2:00 PM to 14:00
		let parts = selectedTime.split(" ");
		if (
			selectedTime.toLowerCase() == "am" ||
			selectedTime.toLowerCase() == "pm"
		) {
			parts = ["12:00", selectedTime.toLowerCase()];
		}
		const timePart = parts[0]; // "2.00"
		const amPmPart = parts[1]; // "PM"
		const [hours, minutes] = timePart.split(":");
		let hoursNum = parseInt(hours, 10);
		const minutesNum = parseFloat(minutes);
		if (amPmPart === "PM" && hoursNum != 12) {
			hoursNum += 12;
		} else if (amPmPart === "AM" && hoursNum == 12) {
			hoursNum = 0;
		}
		const time = new Date();
		time.setHours(hoursNum, minutesNum, 0);

		// Extract the hours, minutes, and seconds as strings and pad them with leading zeros if necessary
		const formattedHours = String(time.getHours()).padStart(2, "0");
		const formattedMinutes = String(time.getMinutes()).padStart(2, "0");
		const timeString = `${formattedHours}:${formattedMinutes}`;
		/*******************************************/
		// call Encoremed create appointment API
		const _tzDate = generateTZDate(selectedDate, timeString, "0"); // 0 to change back default timezone

		let _tenantCode = "";
		if (locationType === "hospital") {
			_tenantCode = tenantCodes[`h_${selectedHospital}`].tenantcode;
		} else if (locationType === "clinic") {
			_tenantCode = tenantCodes[`c_${selectedHospital}`].tenantcode;
		}
		// mail object
		const find_hospital = hospitalListing.find(
			(hospital) => hospital.hospital_id == selectedHospital
		);
		const hospital_name =
			find_hospital?.hospital_name ?? find_hospital?.clinic_name;
		const doctor_name = doctorListing.find(
			(doctor) => doctor.value == selectedDoctorDetails.value
		)?.label;
		// save into db
		save_appointment(patientNric, _tenantCode, selectedHospital)
			.then((res) => {
				setMakeAppointmentLoading(true);

				if (res.status) {
					const apptID = res?.data?.id;
					let icData = {};
					if (patientNric.length === 12) {
						icData = generateFromIc(patientNric);
					} else {
						icData = "-";
					}
					// success
					const _data = {
						name: patientName,
						nric: patientNric,
						date: _tzDate,
						doctorId: selectedDoctorDetails.value,
						tenantcode: _tenantCode,
						phoneNumber: patientPhoneNum,
						callingCode: patientCallingCode,
						email: patientEmail,
						dob: icData.dob, // YYYY-MM-DD
						gender: patientGender, //MALE / FEMALE
						nationality: residenceCode, //MYS
						visitTypeId: selectedVisitType.id,
						PaymentType: selectedPaymentType,
						extraFields: extraFieldsValue,
					};

					createAppointment(_data)
						.then((res) => {
							if (!res.status) {
								var _err = res?.reason.response.data.message;
								if (res?.reason?.response?.data?.errors?.patient) {
									const patientErrors =
										res?.reason?.response?.data?.errors?.patient;
									for (let key in patientErrors) {
										if (patientErrors.hasOwnProperty(key)) {
											_err = patientErrors[key];
										}
									}
								}
								// handle error
								Swal.fire({
									title: "Oops",
									text: _err || res?.reason.response.data.message, //res?.reason ?? res?.message
									icon: "error",
								});
								return false;
							}
							const appt_code = res?.data?.appointment?.code;
							const appt_id = res?.data?.appointment?.id;
							const dataToStore = {
								id: apptID,
								doctor_name,
								appt_id,
								appt_code,
								appt_date: _tzDate,
								patient_name: res?.data?.appointment?.patient?.name,
							};
							// update appointment
							update_appointment(dataToStore)
								.then((res) => {
									// revamp selectedTime from 02:00pm to 02:00:00pm
									const _time = `${String(timePart).padStart(
										2,
										"0"
									)}:00${amPmPart}`;

									const mailObj = {
										to: patientEmail,
										recipient: patientName,
										subject: "Appointment Success",
										body: "", // done in API
										dob: _data.dob,
										phone: `${patientCallingCode}${patientPhoneNum}`,
										hospital: hospital_name,
										doctor: doctor_name,
										visitTypeId: selectedVisitType.id,
										visitTypeName: selectedVisitType.name,
										PaymentType: selectedPaymentType,
										appointment_date: `${selectedDate} ${_time}`,
										appointment_code: appt_code,
									};

									send_mail(mailObj, "appointment").then((res) => {
										onClose();
										Swal.fire({
											title: "Thank you!",
											text: "Make appointment successfully",
											icon: "success",
											confirmButtonText: "Back To Home",
											iconColor: "#39B5B2", // for success
										}).then((result) => {
											if (result.isConfirmed) {
												window.location.href = "/";
											}
										});
									});
								})
								.catch((err) => {
									console.log(err);
									Swal.fire({
										title: "Oops!",
										text: err,
										icon: "warning",
									});
								});
						})
						.catch((err) => {
							console.log(err);
							Swal.fire({
								title: "Oops!",
								text: err,
								icon: "warning",
							});
						});
				} else {
					// error
					Swal.fire({
						title: "Oops!",
						text: res.message ?? res.reason,
						icon: "warning",
					});
				}
			})
			.catch((err) => {
				setMakeAppointmentLoading(false);

				console.log(err);
				Swal.fire({
					title: "Oops!",
					text: err,
					icon: "warning",
				});
			})
			.finally(() => {
				setMakeAppointmentLoading(false);
			});
	};

	const availableDatesStyle = { color: "#39b5b2" };
	const disabledDatesStyle = { color: "lightgray" };
	const footer = (
		<div
			style={{
				display: "flex",
				flexDirection: "row",
				marginTop: "20px",
				flexWrap: "wrap",
			}}
		>
			<div
				style={{
					display: "flex",
					flexDirection: "row",
					marginRight: "30px",
					fontSize: "10px",
				}}
			>
				<BsFillSquareFill color="#39b5b2" style={{ marginRight: "5px" }} />
				<p style={{ lineHeight: "10px", fontSize: "11px" }}>Available</p>
			</div>
			<div
				style={{
					display: "flex",
					flexDirection: "row",
					marginRight: "30px",
					fontSize: "10px",
				}}
			>
				<BsFillSquareFill style={{ marginRight: "5px" }} />
				<p style={{ lineHeight: "10px", fontSize: "11px" }}>Not Available</p>
			</div>
			<div
				style={{
					display: "flex",
					flexDirection: "row",
					marginRight: "10px",
					fontSize: "10px",
				}}
			>
				<BsFillSquareFill color="#967F65" style={{ marginRight: "5px" }} />
				<p style={{ lineHeight: "10px", fontSize: "11px" }}>Selected</p>
			</div>
			<div
				style={{
					display: "flex",
					flexDirection: "row",
					marginRight: "10px",
					fontSize: "10px",
				}}
			>
				<BsFillSquareFill color="#e78076" style={{ marginRight: "5px" }} />
				<p style={{ lineHeight: "10px", fontSize: "11px" }}>Booking Full</p>
			</div>
		</div>
	);

	let formattedDate = "";
	if (selectedDate) {
		formattedDate = new Date(selectedDate)?.toLocaleDateString("en-US", {
			year: "numeric",
			month: "short",
			day: "numeric",
		});
	}

	const isDateAllowed = (date) => {
		const formattedDate = new Date(date);
		formattedDate.setDate(formattedDate.getDate() + 1);
		return allowedDates?.includes(formattedDate.toISOString().split("T")[0]);
	};

	// FETCH HOSPITAL / CLINIC LISTING
	useEffect(() => {
		const fetchData = async () => {
			try {
				const res = await fetchHospitalListing(limit, offset);

				const hospitalListing = res.data.listing;
				const clinicListing = res.data.clinic_listing;
				const filteredClinicListing = clinicListing.filter(
					(clinic) =>
						clinic.clinic_name !== "KPJ Lablink Medical Laboratory" &&
						clinic.clinic_name !== "KPJ Kuantan Care & Wellness Centre" &&
						clinic.clinic_name !== "Love Care Centre, Sibu"
				);
				const combinedListing = [...hospitalListing, ...filteredClinicListing];

				setHospitalListing(combinedListing);

				// assign tenant code, used in submit form
				const _tenantCodeListHospital = hospitalListing.reduce(
					(acc, element) => {
						const key = `h_${element.hospital_id}`;
						acc[key] = {
							hospital_id: element.hospital_id,
							tenantcode: element.tenantcode,
						};
						return acc;
					},
					{}
				);

				const _tenantCodeListClinic = filteredClinicListing.reduce(
					(acc, element) => {
						const key = `c_${element.clinic_id}`;
						acc[key] = {
							clinic_id: element.clinic_id,
							tenantcode: element.tenantcode,
						};
						return acc;
					},
					{}
				);

				// Combine tenant code objects
				const combinedTenantCodeList = Object.assign(
					{},
					_tenantCodeListHospital,
					_tenantCodeListClinic
				);

				setTenantCodes(combinedTenantCodeList);
			} catch (err) {
				console.error("Error fetching hospital listing:", err);
			}

			try {
				await fetchCountriesListing();
			} catch (err) {
				console.error("Error fetching countries listing:", err);
			}
		};

		fetchData();
	}, []);

	// FETCH SPECIALITIES LISTING
	useEffect(() => {
		const fetchData = async () => {
			if (selectedHospital) {
				try {
					let specialityListing = [];
					const data = await api_get_subspeciality(
						selectedLanguage,
						locationType === "hospital" ? selectedHospital : 0,
						locationType === "clinic" ? selectedHospital : 0
					);

					specialityListing = data.data;

					const revampedSpecialityListing = specialityListing
						?.map((speciality) => ({
							sid: speciality.subspecialty_id,
							name: speciality.name,
						}))
						.sort((a, b) => a.name.localeCompare(b.name));

					setDoctorSpecialisations(revampedSpecialityListing);
				} catch (error) {
					console.error(error);
				}
			}
		};

		fetchData();
	}, [selectedHospital, selectedLanguage]);

	// FETCH SPECIALITIES LISTING
	useEffect(() => {
		if (prefillData?.selected_date) {
			handleDateChange(dayjs(selectedDate).$d);
		}
	}, [tenantCodes]);

	// FETCH DOCTOR FROM SELECTED HOSPITAL/CLINIC
	useEffect(() => {
		const fetchDoctorListing = async (selectedHospital) => {
			try {
				const data = await api_em_doctor_listing(
					locationType === "hospital" ? selectedHospital : 0,
					locationType === "clinic" ? selectedHospital : 0
				);

				return data;
			} catch (error) {
				console.error(error);
			}
		};

		if (selectedHospital) {
			const fetchData = (dataKey) => {
				fetchDoctorListing(selectedHospital)
					.then((res) => {
						setDoctorFullListing(res[dataKey]);

						const _list = res[dataKey].map((element) => ({
							value: element.emid,
							label: element.doctor_title + " " + element.doctor_name,
							specialitys: element.specialitys,
							all_specialitys: element.all_specialitys,
						}));

						setSelectedSpecialisation("");
						setSelectedDoctor("");
						setDoctorListing(_list);
					})
					.catch((err) => {
						console.log(err);
					});
			};

			if (locationType === "hospital") {
				fetchData("data");
			} else if (locationType === "clinic") {
				fetchData("clinic");
			}
		}
	}, [selectedHospital]);

	// fetch doctor list based on selected specialisations
	useEffect(() => {
		const filterDoctorBySpeciality = (selectedSpecialisation, doctors) => {
			doctors =
				prefillData?.specialtys === "" ||
				selectedSpecialisation == "noSpecialisation"
					? doctors.filter((doctor) => doctor?.all_specialitys?.length == 0)
					: doctors.filter((doctor) =>
							doctor?.all_specialitys?.includes(selectedSpecialisation)
					  );
			// check main and sub specs
			return doctors;
			/*********************************/
			// deprecated on 30/7/2024, only check main specs
			// return doctors.filter(
			//   (doctor) => doctor.specialitys === selectedSpecialisation
			// );
			/*********************************/
		};

		const result = selectedSpecialisation;

		if (selectedSpecialisation) {
			let _list = [];

			doctorFullListing.forEach((element) => {
				_list.push({
					value: element.emid,
					label: element.doctor_title + " " + element.doctor_name,
					specialitys: element.specialitys,
					all_specialitys: element.all_specialitys,
				});
			});

			setDoctorListing(filterDoctorBySpeciality(result, _list));
		}
	}, [selectedSpecialisation]);

	useEffect(async () => {
		const updateSelectedSpecialisation = (selectedDoctor) => {
			if (doctorSpecialisations) {
				const findDoctor = doctorListing?.find(
					(doctor) => doctor.value === selectedDoctor
				);

				if (findDoctor) {
					if (selectedSpecialisation) {
						const specs = findDoctor.all_specialitys;
						const foundSpecialisation = doctorSpecialisations?.find(
							(specialisation) =>
								specs.includes(specialisation?.name) &&
								selectedSpecialisation == specialisation?.name
						);
						setSelectedSpecialisation(foundSpecialisation?.name || "");
					} else {
						const spe = findDoctor.specialitys;
						const foundSpecialisation = doctorSpecialisations?.find(
							(specialisation) => specialisation?.name.includes(spe)
						);
						setSelectedSpecialisation(foundSpecialisation?.name || "");
					}
				}
			} else {
				const findDoctor = doctorListing?.find(
					(doctor) => doctor.value === selectedDoctor
				);

				if (findDoctor) {
					if (selectedSpecialisation) {
						const specs = findDoctor.all_specialitys;
						const foundSpecialisation = doctorSpecialisations?.find(
							(specialisation) =>
								specs.includes(specialisation?.name) &&
								selectedSpecialisation == specialisation?.name
						);
						setSelectedSpecialisation(foundSpecialisation?.name || "");
					} else {
						const spe = findDoctor.specialitys;
						const foundSpecialisation = doctorSpecialisations?.find(
							(specialisation) => specialisation?.name.includes(spe)
						);
						setSelectedSpecialisation(foundSpecialisation?.name || "");
					}
				}
			}

			setSelectedDoctorDetails(assignDoctorDetails());
			setselectedDoctorSpecialty(assignSelectedDoctorSpecialty());
			assignSelectedDate();
			setPatientResidence(assignSelectedCountry());
		};

		// for additional fiels
		const fetchDoctorData = async (doctorId, tenantCode) => {
			try {
				const res = await getDoctor(doctorId, tenantCode);
				const resData = res.data.doctor;
				setExtraFields(resData.config.appointmentExtraFields);
				setVisitTypes(resData.visitTypes);
				setIsAdditionalFields(
					resData.config.appointmentExtraFields.length > 0 ||
						resData.visitTypes.length > 0
				);
			} catch (error) {
				// Handle errors
			}
		};

		if (selectedDoctor) {
			updateSelectedSpecialisation(selectedDoctor);

			let _tenantCode =
				locationType === "hospital"
					? tenantCodes[`h_${selectedHospital}`]?.tenantcode
					: locationType === "clinic"
					? tenantCodes[`c_${selectedHospital}`]?.tenantcode
					: "";

			fetchDoctorData(selectedDoctor, _tenantCode);
		} else if (prefillData?.doctor_id) {
			updateSelectedSpecialisation(prefillData.doctor_id);
		} else if (prefillData?.specialtys) {
			setSelectedSpecialisation(prefillData?.specialtys || "");
		}
	}, [
		selectedDoctor,
		prefillData?.doctor_id,
		doctorSpecialisations,
		doctorListing,
		selectedDoctorDetails,
	]);

	useEffect(() => {
		const country = countriesWithCode?.find(
			(country) => country.name === patientResidence
		);
		if (country) {
			setResidenceCode(country.code);
			setPatientCallingCode("+" + country.telCode);
		} else {
			console.log("Country not found");
		}
	}, [patientResidence]);

	useEffect(() => {
		if (isLogging) {
			api_get_account()
				.then((res) => {
					if (res.status === 200) {
						handleAccountData(res.data.data.account, res.data.data.country);
					}
				})
				.catch((error) => {
					if (error.response.data?.data?.account) {
						// treat 422 with account data like a "success"
						handleAccountData(
							error.response.data.data.account,
							error.response.data.data.country
						);
					} else {
						console.error(
							"Unexpected API error:",
							error.response?.data || error
						);
					}
				});
		}
	}, [isOpen]);

	const assignDoctorDetails = () => {
		try {
			return doctorListing?.find(
				(doctor) =>
					doctor?.value == prefillData?.doctor_id ||
					doctor?.value == selectedDoctor ||
					doctor?.label == prefillData?.doctor_name
			);
		} catch (error) {
			console.error("Unexpected error occur in assignDoctorDetails :", error);
		}
	};

	const assignSelectedDoctorSpecialty = () => {
		try {
			if (!selectedDoctorDetails?.specialty) {
				setSelectedSpecialisation("");
			}
			const specialty = prefillData?.specialtys
				? selectedDoctorDetails
					? doctorSpecialisations?.find(
							(specialisation) =>
								specialisation?.name ==
								selectedDoctorDetails?.all_specialitys[0]
					  )
					: doctorSpecialisations?.find(
							(specialisation) =>
								specialisation?.name == prefillData?.specialtys
					  )
				: {};

			setSelectedSpecialisation(specialty?.name);

			return specialty;
		} catch (error) {
			console.error(
				"Unexpected error occur in assignSelectedDoctorSpecialty",
				error
			);
		}
	};

	const assignSelectedDate = () => {
		try {
			const isoDate = prefillData?.selected_date
				? new Date(prefillData?.selected_date).toISOString()
				: "";

			setSelectedDate(
				prefillData?.selected_date ? prefillData?.selected_date : ""
			);

			return isoDate;
		} catch (error) {
			console.error("Unexpected error occur in assignSelectedDate", error);
		}
	};

	const assignSelectedCountry = () => {
		try {
			const country =
				patientResidence ??
				countriesListing?.find((country) => country.country_name == "Malaysia");

			setPatientResidence(country?.country_name);

			return country?.country_name;
		} catch (error) {
			console.error("Unexpected error occur in assignSelectedCountry", error);
		}
	};

	// helper to avoid repeating logic
	const handleAccountData = (patient, countries) => {
		setPatientName(patient.first_name);
		setPatientNric(patient.nric?.replace(/-/g, ""));
		setPatientGender(patient.gender === "1" ? "MALE" : "FEMALE");
		setPatientCallingCode(
			patient.country_code != 0 ? `+${patient.country_code}` : "+60"
		);
		setPatientPhoneNum(patient.phone_number);
		setPatientEmail(patient.email);

		const country = countriesListing?.find(
			(c) => c.country_id === patient.country_of_resident
		);
		if (country) {
			setPatientResidence(country.country_name);
		}
	};

	const onChangeDropdownHospitalListingHandler = () => {
		try {
			setCurrentStep(1);
			setSelectedSpecialisation("");
			setSelectedDoctor("");
			setSelectedDate("");
			setSelectedTime("");
			setSelectedDoctorDetails({});
			setselectedDoctorSpecialty({});
			setIsAdditionalFields(false);
		} catch (error) {
			console.error(
				"Unexpected error occur in onChangeDropdownHospitalListingHandler",
				error
			);
		}
	};

	useEffect(() => {
		onChangeDropdownHospitalListingHandler();
	}, [selectedHospital]);

	useEffect(() => {
		if (selectedDoctorDetails?.value && selectedHospital && tenantCodes) {
			handleDatePickerChange(new Date());
		}
	}, [selectedDoctorDetails, selectedHospital, tenantCodes]);

	return (
		<div className="AppointmentPopupContainer">
			<Dialog open={isOpen} className="appointment-popup-section">
				<div style={{ height: "30px" }}></div>
				<IconButton
					aria-label="close"
					onClick={handleClose}
					style={{ position: "absolute", top: "2%", right: "2%" }}
				>
					<img
						src="/img/icon/close-modal.png"
						alt=""
						style={{ width: "15px" }}
					/>
				</IconButton>
				<DialogTitle className="appointment_header_web_view">
					Make An Appointment
				</DialogTitle>
				<div className="appointment_header_mob_view">
					<button
						onClick={handleClose}
						style={{ background: "transparent", border: "none" }}
					>
						<i
							className="fa fa-chevron-left"
							aria-hidden="true"
							style={{ marginRight: "10px" }}
						></i>
						Back
					</button>
					<DialogTitle>Make An Appointment</DialogTitle>
				</div>

				<div id="formContainer">
					<form>
						<fieldset>
							{currentStep === 1 && (
								<>
									<DialogContent>
										<div className="appointment-popup">
											<div style={{ marginBottom: "5px" }}>
												<div className="col-12">
													<div className="selection-dropdown">
														{invalidForm.includes("selectedHospital") ? (
															<label htmlFor="Hospital" className="text-danger">
																Hospital: <span className="text-danger">*</span>
															</label>
														) : (
															<label htmlFor="Hospital">
																Hospital: <span className="text-danger">*</span>
															</label>
														)}
														<DropdownHospitalListing
															labelFor="Hospital"
															options={hospitalListing}
															disabled={prefillData?.hospital_id ? true : false}
															setSelectedHospital={setSelectedHospital}
															selectedHospital={selectedHospital}
															setLocationType={setLocationType}
															onChange={onChangeDropdownHospitalListingHandler}
														/>
													</div>
												</div>
											</div>

											<div className="row" style={{ rowGap: "5px" }}>
												<div className="col-12 col-xl-6 col-lg-6 col-md-6 col-sm-6">
													<div className="selection-dropdown">
														{invalidForm.includes("selectedSpecialisation") ? (
															<label
																htmlFor="Specialisation"
																className="text-danger"
															>
																Specialisation:{" "}
																<span className="text-danger">*</span>
															</label>
														) : (
															<label htmlFor="Specialisation">
																Specialisation:{" "}
																<span className="text-danger">*</span>
															</label>
														)}

														<DropdownSpecialisationListing
															labelFor="Specialisation"
															options={doctorSpecialisations}
															disabled={
																prefillData?.specialtys ||
																prefillData?.doctor_id ||
																!selectedHospital
																	? true
																	: false
															}
															setSelectedSpecialisation={
																setSelectedSpecialisation
															}
															selectedHospital={selectedHospital}
															defaultValue={selectedDoctorSpecialty?.name}
														/>
													</div>
												</div>
												<div className="col-12 col-xl-6 col-lg-6 col-md-6 col-sm-6">
													<div className="selection-dropdown">
														{invalidForm.includes("selectedDoctor") ? (
															<label
																htmlFor="DoctorName"
																className="text-danger"
															>
																Doctor Name:{" "}
																<span className="text-danger">*</span>
															</label>
														) : (
															<label htmlFor="DoctorName">
																Doctor Name:{" "}
																<span className="text-danger">*</span>
															</label>
														)}

														<DropdownDoctorListing
															defaultValue={selectedDoctorDetails?.value}
															labelFor="DoctorName"
															options={doctorListing}
															disabled={prefillData?.doctor_id ? true : false}
															setValue={handleDoctorChange}
														/>
													</div>
												</div>
											</div>
											<div className="select_date_time">
												<h3>Select date and time</h3>

												<div
													className="row"
													style={{ gap: "10px", padding: "0 10px" }}
												>
													<div className="col-6 col-xl-5 col-lg-5 col-md-5 selection-dropdown-date-time">
														<div
															style={{
																display: "flex",
																flexDirection: "column",
																position: "relative",
															}}
														>
															<div
																style={{
																	display: "flex",
																	justifyContent: "space-between",
																}}
															>
																<label htmlFor="date">Date</label>
																{/* <button
                                  type="button"
                                  onClick={() => setIsCalendarOpen(true)}
                                >
                                  Edit
                                </button> */}
															</div>
															<input
																type="text"
																value={
																	formattedDate
																		? formattedDate
																		: "Please select a date"
																}
																readOnly
																style={{
																	fontWeight: formattedDate ? "bold" : "300",
																	color: formattedDate ? "black" : "#A7A7A7",
																}}
															/>
															<FaCalendarAlt
																color="#39B5B2"
																style={{
																	position: "absolute",
																	right: "3px",
																	bottom: "0",
																	cursor: "pointer",
																}}
																onClick={() => setIsCalendarOpen(true)}
															/>
															{isCalendarOpen && (
																<div className="modal-background">
																	<div
																		style={{
																			display: "flex",
																			alignItems: "center",
																			justifyContent: "center",
																			height: "100vh",
																		}}
																	>
																		<div
																			style={{
																				background: "white",
																				padding: "20px",
																				borderRadius: "30px",
																				position: "relative",
																			}}
																		>
																			<DayPicker
																				mode="single"
																				selected={selectedDate}
																				onSelect={(date) => {
																					if (isDateAllowed(date)) {
																						handleDateChange(date);
																						setIsCalendarOpen(false);
																					}
																				}}
																				onMonthChange={handleDatePickerChange}
																				modifiers={{
																					availableDays: allowedDates?.map(
																						(date) => new Date(date)
																					),
																					disabledDays: (date) =>
																						!isDateAllowed(date),
																				}}
																				modifiersStyles={{
																					availableDays: availableDatesStyle,
																					disabledDays: disabledDatesStyle,
																				}}
																				footer={footer}
																				styles={{
																					caption: { color: "#967F65" },
																					head: { color: "#967F65" },
																					day: { fontWeight: "600" },
																				}}
																			/>
																			<button
																				type="button"
																				style={{
																					position: "absolute",
																					background: "transparent",
																					top: "20px",
																					right: "20px",
																					border: "0",
																				}}
																				onClick={() => setIsCalendarOpen(false)}
																			>
																				X
																			</button>
																		</div>
																	</div>
																</div>
															)}
														</div>
													</div>
													<div className="col-6 col-xl-5 col-lg-5 col-md-5">
														<div
															className="selection-dropdown"
															style={{ background: "#E9F8F8" }}
														>
															<label htmlFor="Time">Time</label>
															<Dropdown
																labelFor="Time"
																options={allowedTimes}
																setVal={setSelectedTime}
																value={selectedTime}
															/>
														</div>
													</div>
												</div>
											</div>
											<div
												className="patients_details"
												style={{
													// borderBottom: "1px solid #9e9e9e",
													padding: "0 0 3% 0",
												}}
											>
												<h3>Patient's Details</h3>
												<div
													className="row"
													style={{
														marginBottom: "5px",
														rowGap: "5px",
													}}
												>
													<div className="col-12 col-xl-6 col-lg-6 col-md-6">
														<div className="_patient_details_input">
															{invalidForm.includes("patientName") ? (
																<label htmlFor="Name" className="text-danger">
																	Name: <span className="text-danger">*</span>
																</label>
															) : (
																<label htmlFor="Name">
																	Name: <span className="text-danger">*</span>
																</label>
															)}
															<TextBox
																className="w-100"
																placeholder="Type your name"
																value={patientName}
																onChange={(e) => setPatientName(e.target.value)}
															/>
														</div>
													</div>
													<div className="col-12 col-xl-6 col-lg-6 col-md-6">
														<div className="_patient_details_input">
															{invalidForm.includes("patientNric") ? (
																<label
																	htmlFor="Nic/PassportNo"
																	className="text-danger"
																>
																	NRIC / Passport no.:{" "}
																	<span className="text-danger">*</span>
																</label>
															) : (
																<label htmlFor="Nic/PassportNo">
																	NRIC / Passport no.:{" "}
																	<span className="text-danger">*</span>
																</label>
															)}
															<TextBox
																className="w-100"
																placeholder="Type your NRIC without `-` / Passport no."
																value={patientNric}
																type="text"
																onChange={handleNricInput}
															/>
														</div>
													</div>
												</div>

												<div
													className="row"
													style={{ marginBottom: "5px", rowGap: "5px" }}
												>
													<div className="col-12 col-xl-6 col-lg-6 col-md-6">
														<div className="selection-dropdown">
															{invalidForm.includes("patientResidence") ? (
																<label
																	htmlFor="Residence"
																	className="text-danger"
																>
																	Country of Residence:{" "}
																	<span className="text-danger">*</span>
																</label>
															) : (
																<label htmlFor="Residence">
																	Country of Residence:{" "}
																	<span className="text-danger">*</span>
																</label>
															)}
															<DropdownCountry
																labelFor="Residence"
																options={countriesListing}
																setVal={setPatientResidence}
																value={
																	patientResidence
																		? patientResidence
																		: "Malaysia"
																}
															/>
														</div>
													</div>
													<div className="col-12 col-xl-6 col-lg-6 col-md-6">
														<div className="selection-dropdown">
															{invalidForm.includes("patientGender") ? (
																<label htmlFor="Gender" className="text-danger">
																	Gender: <span className="text-danger">*</span>
																</label>
															) : (
																<label htmlFor="Gender">
																	Gender: <span className="text-danger">*</span>
																</label>
															)}
															<Dropdown
																labelFor="Gender"
																options={genderoptions}
																setVal={setPatientGender}
																value={patientGender}
															/>
														</div>
													</div>
												</div>
												<div className="row" style={{ rowGap: "5px" }}>
													<div className="col-12 col-xl-6 col-lg-6 col-md-6 ">
														<div className="_patient_details_input">
															{invalidForm.includes("patientPhoneNum") ? (
																<label
																	htmlFor="patientPhoneNum"
																	className="text-danger"
																>
																	Phone Number:{" "}
																	<span className="text-danger">*</span>
																</label>
															) : (
																<label htmlFor="patientPhoneNum">
																	Phone Number:{" "}
																	<span className="text-danger">*</span>
																</label>
															)}

															<div
																style={{
																	display: "flex",
																	alignItems: "center",
																}}
															>
																<input
																	type="text"
																	name="patientCallingCode"
																	value={patientCallingCode}
																	onChange={(e) => {
																		let inputValue = e.target.value.replace(
																			/\D/g,
																			""
																		); // Remove non-digit characters
																		setPatientCallingCode("+" + inputValue); // Add the leading "+" sign
																	}}
																	required
																	placeholder="+60"
																	maxLength={3}
																	style={{
																		border: "none",
																		width: "35px",
																		paddingLeft: "0.5rem",
																	}}
																/>
																-
																<input
																	type="text"
																	name="patientPhoneNum"
																	value={patientPhoneNum}
																	onChange={(e) => {
																		let inputValue = e.target.value.replace(
																			/\D/g,
																			""
																		); // Remove non-digit characters
																		setPatientPhoneNum(inputValue);
																	}}
																	required
																	placeholder="1234567890"
																	maxLength={20}
																	style={{
																		border: "none",
																		width: "100%",
																		paddingLeft: "0.5rem",
																	}}
																/>
															</div>
														</div>
													</div>
													<div className="col-xl-6 col-lg-6 col-md-6">
														<div className="_patient_details_input">
															{invalidForm.includes("patientEmail") ? (
																<label htmlFor="email" className="text-danger">
																	Email: <span className="text-danger">*</span>
																</label>
															) : (
																<label htmlFor="email">
																	Email: <span className="text-danger">*</span>
																</label>
															)}
															<TextBox
																className="w-100"
																placeholder="Type your email"
																value={patientEmail}
																onChange={(e) =>
																	setPatientEmail(e.target.value)
																}
															/>
														</div>
													</div>
												</div>
											</div>
											{isAdditionalFields && (
												<div
													className="additional_fields"
													style={{ paddingBottom: "3%" }}
												>
													{/* <h3>Additional Fields</h3> */}
													<div className="row">
														{visitTypes.length > 0 && (
															<div className="col-12 col-lg-6 col-md-6 col-sm-6">
																<div style={{ padding: "0 0.5rem" }}>
																	<h3>Visit Type</h3>
																	{visitTypes?.map((type, index) => (
																		<div
																			key={index}
																			style={{
																				display:
																					type.id == 4996 || type.id == 4997
																						? "flex"
																						: "none",
																				alignItems: "center",
																			}}
																		>
																			<input
																				type="radio"
																				id={`radio-${index}`}
																				value={type.id}
																				checked={
																					selectedVisitType.id === type.id
																				}
																				onChange={(e) =>
																					setSelectedVisitType({
																						id: e.target.value,
																						name: type.name,
																					})
																				}
																			/>
																			<label
																				className="visit-type-label"
																				htmlFor={`radio-${index}`}
																			>
																				{type.name}
																			</label>
																		</div>
																	))}
																</div>
															</div>
														)}
														{extraFields?.map((field, index) => {
															let inputElement;
															switch (field?.type?.toLowerCase()) {
																case "select":
																	inputElement = (
																		<div
																			style={{
																				position: "relative",
																				backgroundColor: "#eaedf8",
																				height: "100%",
																				borderRadius: "5px",
																				padding: "0.5rem",
																			}}
																		>
																			<div
																				style={{
																					position: "relative",
																					zIndex: "2",
																				}}
																			>
																				<select
																					value={extraFieldsValue?.[field.name]}
																					onChange={(e) =>
																						handleExtraFieldsInput(
																							index,
																							e.target.value
																						)
																					}
																				>
																					<option value="">
																						Please select
																					</option>
																					{field?.options?.map(
																						(option, index) => (
																							<option
																								key={index}
																								value={option.value}
																							>
																								{option.value}
																							</option>
																						)
																					)}
																				</select>
																			</div>
																			<img
																				src="./img/icon/dropdown-icon.png"
																				alt=""
																				style={{
																					position: "absolute",
																					right: "20px",
																					bottom: "38%",
																					width: "10px",
																				}}
																			/>
																		</div>
																	);
																	break;

																default:
																	inputElement = (
																		<div
																			style={{
																				position: "relative",
																				backgroundColor: "#eaedf8",
																				height: "100%",
																				borderRadius: "5px",
																				padding: "0.5rem",
																			}}
																		>
																			<input
																				value={extraFieldsValue?.[field.name]}
																				onChange={(e) =>
																					handleExtraFieldsInput(
																						index,
																						e.target.value
																					)
																				}
																				type="text"
																				style={{ background: "transparent" }}
																				className="w-100"
																			/>
																		</div>
																	);
																	break;
															}
															return (
																<div
																	key={index}
																	className="col-12 col-lg-6 col-md-6 col-sm-6"
																>
																	<div>
																		<h3>{field.name}</h3>
																		{inputElement}
																	</div>
																</div>
															);
														})}
													</div>
												</div>
											)}
										</div>
									</DialogContent>
									<DialogActions>
										<Button
											// onClick={() => setCurrentStep(currentStep + 1)}
											onClick={() => handleFormStep("next")}
											color="primary"
										>
											Next
										</Button>
									</DialogActions>
								</>
							)}

							{/* temporary set as 2 for current step */}
							{currentStep === 2 && (
								<>
									<DialogContent>
										<div className="confirm_appointment_details">
											<h3>Please confirm your appointment</h3>

											<div className="row">
												<div
													className="col-xl-4 col-lg-4 col-md-6"
													style={{ marginBottom: "24px" }}
												>
													<div>
														<label htmlFor="Username">Username</label>
													</div>
													<div className="confirm_patient_name">
														{patientName}
													</div>
													<div className="confirm_patient_name">
														{patientNric}
													</div>
												</div>
												<div className="col-6 col-xl-4 col-lg-4 col-md-6 ">
													<div>
														<label htmlFor="Date">Date</label>
													</div>
													<div className="confirm-details-box">
														{selectedDate}
													</div>
												</div>
												<div className="col-6 col-xl-4 col-lg-4 col-md-6 ">
													<div>
														<label htmlFor="Time">Time</label>
													</div>
													<div className="confirm-details-box">
														{isAppointmentRequest
															? selectedTime.toLowerCase().includes("am")
																? "AM"
																: "PM"
															: selectedTime}
													</div>
												</div>
											</div>
										</div>
									</DialogContent>
									<DialogActions>
										<Button
											onClick={() => handleFormStep("prev")}
											color="primary"
										>
											Previous
										</Button>
										<Button
											onClick={handleButtonClick}
											color="primary"
											className="make_an_appointment"
										>
											{makeAppointmentLoading
												? "Loading..."
												: "Make An Appointment"}
										</Button>
									</DialogActions>
								</>
							)}
						</fieldset>
					</form>
					<div style={{ height: "20px" }}></div>
				</div>
			</Dialog>
		</div>
	);
};

export default MakeAnAppointmentPopup;
